import Api from './api';

export default {
  getStatus(programId) {
    const url = programId ? `/v1/ai-quota/${programId}` : '/v1/ai-quota';
    return new Promise((resolve, reject) => {
      Api.get(url)
        .then(res => resolve(res.data))
        .catch(reject);
    });
  },
};
